<div class="acceptance-buttons">
  <app-button [ngClass]="yesBtnClass" classes="small" [text]="textPositive" (onClick)="onValidationSelection($event, true)" [disabled]="!isValidationEnabled">
  </app-button>
  <app-button [ngClass]="noBtnClass" classes="small" [text]="textNegative" (onClick)="onValidationSelection($event, false)" [disabled]="!isValidationEnabled"></app-button>
</div>
